import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Button from "../Button";
import FormTextInput from "../FormTextInput";
import { errorToast, successToast } from "../../toast";
import { useMakeSecondary } from "../../api/emissions-sources";
import {
    MakeSecondaryFormValues,
    makeSecondaryFormValidationSchema,
} from "./MakeSecondaryFormValues";
import { Alert } from "@mui/material";

type MakeSecondaryFormProps = {
    emissionsSourceid: number;
    onCancel: () => void;
    onSubmit: () => void;
};

const MakeSecondaryForm = ({
    emissionsSourceid,
    onCancel,
    onSubmit,
}: MakeSecondaryFormProps) => {
    const methods = useForm<MakeSecondaryFormValues>({
        mode: "onSubmit",
        resolver: yupResolver(makeSecondaryFormValidationSchema),
    });

    const [request, isSubmitting] = useMakeSecondary(emissionsSourceid);

    const handleMakeSecondaryFormSubmission = async (
        value: MakeSecondaryFormValues
    ) => {
        const response = await request({
            ...value,
        });

        if (!response.success) {
            errorToast(
                "There was a problem saving the emissions source - please try again"
            );
            return;
        }

        successToast("Emissions source updated");
        onSubmit();
    };

    return (
        <>
            <form
                onSubmit={methods.handleSubmit(
                    handleMakeSecondaryFormSubmission
                )}
            >
                <Alert severity="info" className="items-center">
                    Changing this emissions source to secondary will not affect
                    its associated data source. All activity data will be
                    preserved.
                </Alert>
                <div className="space-y-4 mt-5">
                    <FormTextInput
                        required
                        type="text"
                        label="Justification"
                        placeholder="Enter justification for change"
                        {...methods.register("justification")}
                        error={methods.formState.errors.justification}
                    />
                </div>
                <div className="flex justify-end gap-4 mt-10">
                    <Button
                        variant="transparent"
                        type="button"
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button disabled={isSubmitting} type="submit">
                        Make Secondary
                    </Button>
                </div>
            </form>
        </>
    );
};

export default MakeSecondaryForm;
